import { api } from '../createApi';
import { TagType } from '../TagType';

const TAG_BY_LIST = { type: TagType.Department, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.Department as TagType],
  endpoints: {
    getAllDepartments: {
      providesTags: [TAG_BY_LIST],
    },
  },
});
